const feedbackApi = {
  pageQuery: '/kbms/feedback/pageQuery', // 分页查询
  process: '/kbms/feedback/process', // 处理反馈
  queryWaitExists: '/kbms/feedback/queryWaitExists', // 查询是否存在待处理的数据
  add: '/kbms/feedback/add', // 新增反馈
}

export default feedbackApi
